import { render, staticRenderFns } from "./YearPeriodList.vue?vue&type=template&id=3f89cdae&scoped=true"
import script from "./YearPeriodList.vue?vue&type=script&lang=js"
export * from "./YearPeriodList.vue?vue&type=script&lang=js"
import style0 from "./YearPeriodList.vue?vue&type=style&index=0&id=3f89cdae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f89cdae",
  null
  
)

export default component.exports